module.exports = __webpack_public_path__ + "static/top-entry-callout-4766bb2d31a48f2ed59e96b6d092f342.png";